import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { Email, HideSource, RadioButtonChecked } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export type UserStatusMeta = {
  label: string;
  color: string;
  icon: React.ReactNode;
};

export const getUserStatusMeta = (
  status?: number | null,
  translate?: (key: string) => unknown
): UserStatusMeta => {
  if (status === 1) {
    return {
      label: translate ? String(translate('userStatus.active.label')) : 'Ativo',
      color: '#22a820',
      icon: <RadioButtonChecked sx={{ fontSize: 16 }} />,
    };
  }

  if (status === 2) {
    return {
      label: translate ? String(translate('userStatus.invited.label')) : 'Convidado',
      color: '#b48605',
      icon: <Email sx={{ fontSize: 16 }} />,
    };
  }

  return {
    label: translate ? String(translate('userStatus.inactive.label')) : 'Inativo',
    color: '#878787',
    icon: <HideSource sx={{ fontSize: 16 }} />,
  };
};

const UserStatusLegend = () => {
  const { t } = useTranslation('system');
  const items = [
    getUserStatusMeta(1, t),
    getUserStatusMeta(2, t),
    getUserStatusMeta(3, t),
  ];

  return (
    <Stack
      direction="row"
      spacing={1.5}
      sx={{
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        alignItems: 'center',
        mb: 1,
      }}
    >
      {items.map((item) => (
        <Stack
          key={item.label}
          direction="row"
          spacing={0.5}
          sx={{ alignItems: 'center' }}
        >
          <Box sx={{ color: item.color, display: 'flex', alignItems: 'center' }}>
            {item.icon}
          </Box>
          <Typography sx={{ fontSize: 12, color: '#7A7A7A', lineHeight: 1 }}>
            {item.label}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default UserStatusLegend;
